import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './StatusDot.module.css';
export const ARTWORK_STATUSES = ['available', 'reserved', 'sold', 'deposit', 'withdrawn'];
const LABELS = {
    fr: {
        available: 'Disponible',
        reserved: 'Réservée',
        sold: 'Vendue',
        deposit: 'En dépôt / prêtée',
        withdrawn: 'Retirée / archivée',
    },
    en: {
        available: 'Available',
        reserved: 'Reserved',
        sold: 'Sold',
        deposit: 'On loan / consignment',
        withdrawn: 'Withdrawn / archived',
    },
};
/**
 * Statut d'œuvre : toujours une pastille **et** un libellé en encre (2.3, D6).
 * La couleur seule ne porte jamais l'information.
 */
export function StatusDot({ status, lang = 'fr', label, className, ...rest }) {
    const text = label ?? LABELS[lang][status];
    const classes = [styles.wrapper, className].filter(Boolean).join(' ');
    const dotClasses = [styles.dot, status === 'withdrawn' ? styles.dotEmpty : '', styles[status]]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("span", { className: classes, ...rest, children: [_jsx("span", { className: dotClasses, "aria-hidden": "true" }), _jsx("span", { className: styles.label, children: text })] }));
}
//# sourceMappingURL=StatusDot.js.map